
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5.792c1.183 0 2.312.23 3.386.69 1.074.459 2 1.077 2.777 1.855a8.748 8.748 0 011.856 2.777c.46 1.074.69 2.203.69 3.386 0 1.183-.23 2.312-.69 3.386a8.747 8.747 0 01-1.856 2.777 8.747 8.747 0 01-2.777 1.856 8.516 8.516 0 01-3.386.69 8.516 8.516 0 01-3.386-.69 8.748 8.748 0 01-2.777-1.856 8.746 8.746 0 01-1.856-2.777A8.516 8.516 0 01.791 9.5c0-1.183.23-2.312.69-3.386.46-1.074 1.079-2 1.856-2.777A8.747 8.747 0 016.114 1.48 8.516 8.516 0 019.5.791zm0 1.583c-.965 0-1.887.189-2.768.566A7.17 7.17 0 004.46 4.459 7.17 7.17 0 002.94 6.732 6.953 6.953 0 002.375 9.5c0 .965.189 1.887.566 2.768A7.17 7.17 0 004.46 14.54a7.169 7.169 0 002.272 1.519c.88.377 1.803.566 2.768.566.965 0 1.887-.189 2.768-.566a7.168 7.168 0 002.273-1.519 7.169 7.169 0 001.518-2.272c.377-.88.566-1.803.566-2.768 0-.965-.189-1.887-.566-2.768a7.169 7.169 0 00-1.518-2.273 7.169 7.169 0 00-2.273-1.518A6.952 6.952 0 009.5 2.375zm0 2.333c.219 0 .405.078.56.232a.763.763 0 01.232.56v3.672l2.146 2.14c.152.153.229.34.229.563 0 .223-.076.41-.229.563a.765.765 0 01-.563.229.765.765 0 01-.563-.23l-2.375-2.374a.765.765 0 01-.229-.563v-4c0-.218.078-.405.232-.56a.763.763 0 01.56-.232z","fill":"#9E2F00","stroke":"#9E2F00"}})])
          )
        }
      }
    